import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';
import NavigationRows from './NavigationRows';

const NavigationSettingsModalContent = ({
  onClose,
  websiteUrl,
}: {
  onClose: () => void;
  websiteUrl?: string | null;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>
          {t('pageDirectBookingEngine.navigationSettings.title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <NavigationRows websiteUrl={websiteUrl} />
      </Modal.Body>
      <Modal.Footer>
        <ModalFormCancelButton
          closeOnClick={false}
          data-testid="cancel-navigation-settings-button"
          onClick={onClose}
        />
        <ModalFormSubmitButton data-testid="save-navigation-settings-button">
          {t('pageDirectBookingEngine.navigationSettings.save')}
        </ModalFormSubmitButton>
      </Modal.Footer>
    </>
  );
};

export default NavigationSettingsModalContent;
